import { Link } from 'react-router-dom';
import company from '../data/company';
import content from '../data/content';
import { mainNav } from '../data/navigation';
import BrandMark from './BrandMark';
import './Footer.css';

/**
 * Подвал. Реквизиты доступны с любой страницы — это основной маршрут
 * для проверяющего и тендерного специалиста.
 */
function Footer() {
  const year = new Date().getFullYear();
  const copy = content.footer;
  const requisites = content.home;

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <BrandMark size={30} />
            <span className="footer__name">{company.name}</span>
            <p className="footer__tagline">{company.tagline}</p>
          </div>

          <div>
            <p className="footer__title">{copy.sectionsTitle}</p>
            <div className="footer__list">
              {mainNav.map((item) => (
                <Link key={item.to} to={item.to}>
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <p className="footer__title">{copy.requisitesTitle}</p>
            <dl className="footer__req">
              <div>
                <dt>{requisites.innLabel}</dt>
                <dd>{company.inn}</dd>
              </div>
              <div>
                <dt>{requisites.kppLabel}</dt>
                <dd>{company.kpp}</dd>
              </div>
              <div>
                <dt>{requisites.ogrnLabel}</dt>
                <dd>{company.ogrn}</dd>
              </div>
              <div>
                <dt>{requisites.okvedLabel}</dt>
                <dd>{company.okved.split(' — ')[0]}</dd>
              </div>
            </dl>
          </div>

          <div>
            <p className="footer__title">{copy.contactsTitle}</p>
            <div className="footer__list">
              <span>{company.address}</span>
              <a href={company.phoneHref}>{company.phone}</a>
              <a href={`mailto:${company.email}`}>{company.email}</a>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <span>
            © {year} {company.fullName}. {copy.rightsReserved}
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
